import Axios from "axios";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;


export const getOrdersShopsOptions = async () => {
  try {
    const { data } = await Axios.get("/api/v1/order_shops?");
    if(!data?.shops) throw new Error('')
    return { success: true, data: data.shops };
  } catch (e) {
    console.log("error getting ordershops");
    return { success: false, data: [] };
  }
};
